import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_TwoFactorAuthDialog = _resolveComponent("TwoFactorAuthDialog")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "currency-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "currency-page__header" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, " Currency ", -1 /* CACHED */)),
          (_ctx.isUpdateCurrencyListAllowed)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                class: "currency-page__action",
                onClick: _ctx.openTwoFactorDialog
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Save ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_form, { class: "currency-page__form" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "currency-page__form-label" }, [
            _createElementVNode("h3", null, " Available currency ")
          ], -1 /* CACHED */)),
          _createVNode(_component_el_form_item, { class: "currency-page__form-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.availableCurrencyCodeList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.availableCurrencyCodeList) = $event)),
                multiple: "",
                disabled: !_ctx.isUpdateCurrencyListAllowed,
                filterable: "",
                placeholder: "Select currency"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fullCurrencyList, ({ code }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: code,
                      label: code,
                      value: code
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })), [
        [_directive_loading, _ctx.isCurrencyListLoading]
      ]),
      _createVNode(_component_TwoFactorAuthDialog, {
        "is-two-factor-check-required": false,
        action: _ctx.updateAvailableCurrencyCodeListAction
      }, null, 8 /* PROPS */, ["action"])
    ]),
    _: 1 /* STABLE */
  }))
}